import { useQuery } from '@tanstack/react-query';

import { PayStationActiveOperation } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/paystations/pay-station/:payStationId/active-operation/';

type QueryFnType = typeof queryFn;

interface DTO {
    payStationId: string;
    parkingId: string;
}
const queryFn = ({ parkingId, payStationId }: DTO): Promise<PayStationActiveOperation> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, payStationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPayStationActiveOperation, RESOURCE as GET_PAY_STATION_ACTIVE_OPERATION_RESOURCE };
